import { render, staticRenderFns } from "./CreateBlacklistAddress.vue?vue&type=template&id=6db24b5a&"
import script from "./CreateBlacklistAddress.vue?vue&type=script&lang=ts&"
export * from "./CreateBlacklistAddress.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports